var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"rounded-lg",class:{
    'rounded-lg': _vm.rounded,
  },attrs:{"src":_vm.image,"height":_vm.height,"width":_vm.width,"contain":_vm.contain,"lazy-src":_vm.image,"loading":_vm.loading},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-img',{staticClass:"rounded-lg",attrs:{"src":"/images/no_photo.jpg","contain":""}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }